// extracted by mini-css-extract-plugin
var _1 = "home-ot3g8";
var _2 = "link-TeVXb";
var _3 = "name-jD2Na";
export { _1 as "home", _2 as "link", _3 as "name" }
